import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import Gst from './gst/Gst';
import { PermissionGuard } from '../../../components/PermissionGuard';
import UnauthorizedPage from '../../UnAuthorized';
import ChargesAndCoverage from './chargesandcoverage/ChargesAndCoverage';

const BusinessDashboard = () => {
  const navigate = useNavigate();
  const {tab} = useParams();
  const [tabValue, setTabValue] = useState('0');

  // const handleChange = (event, newValue) => {
  //   setTabValue(newValue);
  // };
  // Update tab value from URL parameter on component mount
  useEffect(() => {
    if (tab && ['0', '1'].includes(tab)) {
      setTabValue(tab);
    } else {
      setTabValue('0');
      navigate('/settings/business/0');
      // // Optionally update URL if tab param is invalid or missing
      // navigate('/settings/business/0', { replace: true });
    }
  }, [tab, navigate]);
  
  // Handle tab change and update URL
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    navigate(`/settings/business/${newValue}`);
  };

  return (
    <Box>
      {/* ===========page title================= */}
      <PageHeaderLayout headerTitle={'Business'}>
        <Button variant='contained' onClick={() => navigate(-1)} sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}>
          Back
        </Button>
      </PageHeaderLayout>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            <Tab value="0" label="Gst Details" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
            <Tab value="1" label="Charges & Coverage Details" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            {/* <Tab value="three" label="Item Three" /> */}
          </Tabs>
        </Box>
      </Card>
      {tabValue === '0' && <Gst />}
      {tabValue === '1' && <ChargesAndCoverage />}
    </Box>
  );
}

export default BusinessDashboard;

